<div class="account-dialog">
    <div class="seperator"></div>
    <div class="title" mat-dialog-title>Join the waitlist</div>
    <div class="dialog-body{{sent?' emailsent-body':''}}">
        <form *ngIf="sent===false" class="forget-password-form">
            <div class="form-text">We're still working hard on making sure Rubii is best platform for all sorts of business.</div>
            <div class="text-gap">In the meantime, you can join the waitlist and you'll be first to know of any product updates.</div>
            <mat-card class="text-gap">
                <mat-form-field class="form-field">
                    <input type="text" matInput placeholder="Full name" [formControl]="nameFormControl">
                    <mat-error *ngIf="nameFormControl.hasError('name') && !nameFormControl.hasError('required')">
                        Please enter a valid full name
                    </mat-error>
                    <mat-error *ngIf="nameFormControl.hasError('required')">
                        Full name is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <input type="email" matInput placeholder="Email Address" [formControl]="emailFormControl">
                    <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                        Please enter a valid email address
                    </mat-error>
                    <mat-error *ngIf="emailFormControl.hasError('required')">
                        Email is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <input type="text" matInput placeholder="Company (If applicable)" [formControl]="companyFormControl">
                </mat-form-field>
            </mat-card>
            <button mat-raised-button (click)="join()" class="rubii-btn register-button" color="primary">Register</button>
        </form>
        <div class="join-note">
            By joining the waitlist, you agree to receive news & updates about Rubii. <br>
            You can unsubscribe at any time by contacting support@rubii.io
        </div>
        <ng-container *ngIf="sent">
            <div>Please check your email for the link to reset password.</div>
            <div class="text-gap">If you are still having difficulties logging in, please contact support@rubii.io</div>
        </ng-container>
    </div>
</div>